import deepEqual from 'fast-deep-equal';
import { get } from 'react-hook-form';

/** Treat unset filter fields consistently when comparing to defaults (Clear / chip state). */
export const normalizeFilterValue = (value: unknown): unknown => {
  if (value === undefined || value === null || value === '') {
    return undefined;
  }

  if (Array.isArray(value) && value.length === 0) {
    return undefined;
  }

  return value;
};

export const isFilterFieldActive = (
  values: Record<string, unknown>,
  name: string,
  defaultValues: Record<string, unknown>,
): boolean => {
  const current = normalizeFilterValue(get(values, name));
  const defaults = normalizeFilterValue(get(defaultValues, name));

  return !deepEqual(current, defaults);
};
